import * as _ from 'underscore';

import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToastInstance } from '../../../httpClient/WebHttpClientWithErrorToast';
import { IGroupBasicInfo } from '../../../ts/models/IGroupInfo';
import { SearchActiveDirectoryGroupNameRequest } from '../../../ts/ServerApi/requests/SearchActiveDirectoryGroupNameRequest';
import { GrantLicenseModes, SyncActiveDirectoryGroupRequest } from '../../../ts/ServerApi/requests/SyncActiveDirectoryGroupRequest';
import { IActiveDirectoryGroup, SyncActiveDirectoryGroupsRequest } from '../../../ts/ServerApi/requests/SyncActiveDirectoryGroupsRequest';

const basicGroupInfoToAdGroup = (group: IGroupBasicInfo): IActiveDirectoryGroup => {
  return {
    name: group.name,
    domainName: group.domainName
  };
};

export namespace ActiveDirectoryGroups {

    // search for active directory groups
    export function searchActiveDirectoryGroupName(searchInputText: string): Promise<any> {
        const request = new SearchActiveDirectoryGroupNameRequest({name: searchInputText});
        return WebHttpClientWithErrorToastInstance.sendRequest(request);
    }

    // synchronize a group, if the group does not exist then it will be added
    export function syncAdGroup(groupName: string, groupDomainName: string, siteRole?: string, grantLicenseMode?: GrantLicenseModes): Promise<any> {
        const request = new SyncActiveDirectoryGroupRequest({
            name: groupName,
            domainName: groupDomainName,
            siteRole: siteRole,
            grantLicenseMode: grantLicenseMode
        });
        return WebHttpClientWithErrorToastInstance.sendRequest(request);
    }

    // synchronize groups
    export function syncAdGroups(groups: IGroupBasicInfo[]): Promise<IResult> {
        const adGroups = _.map(groups, basicGroupInfoToAdGroup);
        const request = new SyncActiveDirectoryGroupsRequest(adGroups);
        return WebHttpClientWithErrorToastInstance.sendRequest(request);
    }

}

export type ActiveDirectoryGroups = typeof ActiveDirectoryGroups;
